import {
  Component,
  computed,
  ElementRef,
  EventEmitter,
  input,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'ui-filedrop',
  standalone: true,
  templateUrl: './ui-filedrop.component.html',
  styleUrl: './ui-filedrop.component.scss',
})
export class UiFiledropComponent {
  @Input() disabled = false;
  @Input() invalid = false;
  @Input() multiple = true;
  @Input() title = 'Перетащите файлы сюда или нажмите, чтобы выбрать';
  /** Подпись под основным текстом (например, сколько ещё файлов можно добавить). */
  @Input() hint = '';
  /** Допустимые форматы файлов, например "image/png,image/jpeg,.pdf" */
  @Input() accept = '';
  sizeLimit = input<number>(0);

  @Output() filesSelected = new EventEmitter<File[]>();
  @Output() filesRejected = new EventEmitter<{ files: File[]; accept: string }>();

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  dragOver = false;

  onDragOver(event: DragEvent): void {
    if (this.disabled) return;
    event.preventDefault();
    this.dragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.dragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.dragOver = false;
    if (this.disabled) return;

    const files = event.dataTransfer?.files;
    if (files?.length) this.emit(files);
  }

  onClick(): void {
    if (this.disabled) return;
    this.fileInput.nativeElement.click();
  }

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) this.emit(input.files);
    input.value = '';
  }

  private emit(files: FileList): void {
    let accepted = Array.from(files);
    if (this.accept) {
      const rejected = accepted.filter((f) => !this.isAccepted(f));
      if (rejected.length) {
        this.filesRejected.emit({ files: rejected, accept: this.accept });
      }
      accepted = accepted.filter((f) => this.isAccepted(f));
    }
    if (accepted.length) this.filesSelected.emit(accepted);
  }

  private isAccepted(file: File): boolean {
    const allowed = this.accept.split(',').map((s) => s.trim().toLowerCase());
    const name = file.name.toLowerCase();
    const type = file.type.toLowerCase();
    return allowed.some((entry) => {
      if (entry.startsWith('.')) {
        return name.endsWith(entry);
      }
      if (entry.endsWith('/*')) {
        const prefix = entry.replace('/*', '');
        return type.startsWith(prefix + '/');
      }
      return type === entry;
    });
  }

  sizeLimitMB = computed(() => {
    const limit = this.sizeLimit();
    return limit ? (limit / 1024 / 1024).toFixed(1) : null;
  });

  sizeLimitDisplay = computed(() => {
    const limit = this.sizeLimit();
    if (!limit) return;
    const mb = (limit / 1024 / 1024).toFixed(1);
    return `до ${mb} МБ`;
  });
}
